/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */

import { Themes } from "@vwpfs/mary-air-lib/theme/_Types";

interface ThemeReferences {
    favicon?: string;
    favicon16?: string;
    favicon32?: string;
    faviconApple?: string;
}

export const setThemeReferences = (theme: Themes, references: ThemeReferences) => {
    // Set favicon references
    if (references.favicon) {
        const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
        if (favicon) {
            favicon.href = references.favicon;
        }
    }

    if (references.favicon16) {
        const favicon16 = document.querySelector('link[rel="icon"][sizes="16x16"]') as HTMLLinkElement;
        if (favicon16) {
            favicon16.href = references.favicon16;
        }
    }

    if (references.favicon32) {
        const favicon32 = document.querySelector('link[rel="icon"][sizes="32x32"]') as HTMLLinkElement;
        if (favicon32) {
            favicon32.href = references.favicon32;
        }
    }

    if (references.faviconApple) {
        const faviconApple = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
        if (faviconApple) {
            faviconApple.href = references.faviconApple;
        }
    }

    // Set theme class on body or html element
    document.body.className = document.body.className.replace(/theme-\w+/g, '');
    document.body.classList.add(`theme-${theme}`);
};
